module.exports = __webpack_public_path__ + "img/tz.68cbbca9.svg";